import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {

  methods: {
    getList() {
      var params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value !== '') {
          // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
          if (typeof value == 'string') {
            value = util.trimAllSpace(value);
          }
          this.query[item] = value
          params[item] = value;
          if (item == "ExecutTimeStart" || item == "ExecutTimeEnd") {
            params[item] = util.time2str(value);
          }
        }
      }
      this.lists = [];
      this.loading = true; //拼命加载中显示
      $http.get('api/Bing/GetMatter_List', params).then(res => {
        let {
          StateCode,
          StateMsg,
          Data,
          Cnt
        } = res.data;
        util.doResult(this, res, () => {

          this.loading = false; //拼命加载中隐
          this.lists = Data;
          this.totalSize = Cnt;
          this.getInitData()
        });
      });
    },
    // 获取事件类型
    getInitData() {
      var params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: 1,
        pageSize: 1000,
      };
      this.MatterTypes = [];
      // let type0 = {
      //   'Id': 0,
      //   'MatterTypeName': '-请选择-'
      // }
      this.loading = true; //拼命加载中显示
      $http.get('api/Bing/GetMatterType_List', params).then(res => {
        let {
          StateCode,
          StateMsg,
          Data,
          Cnt
        } = res.data;
        util.doResult(this, res, () => {
          this.MatterTypes = Data
          //this.MatterTypes.unshift(type0) //处理"MatterTypeId": 0
          this.loading = false; //拼命加载中隐藏
        });
      });
    },
    // 删除
    DelList(id) {
      let params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
      };
      let query = {
        Ids: id
      }
      this.loading = true;
      $http.post("api/Bing/ERP_MatterDel", Object.assign({}, params, query)).then(res => {
        let {
          Data,
          Cnt
        } = res.data;
        this.loading = false;
        util.doResult(this, res, () => {
          this.$notify({
            title: '成功',
            message: "删除成功",
            type: 'success'
          });
          this.getList()
        });
      });
    },
  }
}


// WEBPACK FOOTER //
// ./src/pages/Memorandum/SpecialMatter/services.js